import apiCall from 'apps/investcore/apiCalls/subscription-transactions';
import subscriptionsApiCall from 'apps/investcore/apiCalls/subscriptions';
import { columnsGenerator, filterConfig } from 'apps/investcore/components/subscription-transactions/config';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { ListPage } from 'common/ui/admin-CRUD/page';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';

// Subscription plans are a handful today but not hardcoded here - fetched
// once so the "Plan" filter stays correct as plans are added/renamed.
const SubscriptionTransactionsFilterForm = () => {
  const { data: subscriptions, load } = useFetchApiList(subscriptionsApiCall.list, {
    resourceName: 'data',
  });

  useEffect(() => {
    load({ page: 1, page_size: 100 });
  }, []);

  const options = (subscriptions ?? []).map((subscription: any) => ({
    value: subscription.id,
    label: subscription.title,
  }));

  return <DynamicFilterForm fields={filterConfig(options)} />;
};

export const SubscriptionTransactionsListPage = () => (
  <ListPage
    title="Subscription Transactions"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => <SubscriptionTransactionsFilterForm />}
  />
);
